/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export * from './abstractGroupRepresentation';
export * from './abstractUserRepresentation';
export * from './accountRepresentation';
export * from './addGroupCapabilitiesRepresentation';
export * from './alfrescoContentRepresentation';
export * from './alfrescoEndpointRepresentation';
export * from './alfrescoNetworkRepresenation';
export * from './alfrescoSiteRepresenation';
export * from './appDefinition';
export * from './appDefinitionPublishRepresentation';
export * from './appDefinitionRepresentation';
export * from './appDefinitionSaveRepresentation';
export * from './appDefinitionUpdateResultRepresentation';
export * from './appDeploymentRepresentation';
export * from './appModelDefinition';
export * from './assigneeIdentifierRepresentation';
export * from './auditCalculatedValueRepresentation';
export * from './auditDecisionExpressionInfoRepresentation';
export * from './auditDecisionInfoRepresentation';
export * from './auditDecisionRuleInfoRepresentation';
export * from './auditLogEntryRepresentation';
export * from './auditLogFormDataRepresentation';
export * from './boxContent';
export * from './boxUserAccountCredentialsRepresentation';
export * from './bulkUserUpdateRepresentation';
export * from './changePasswordRepresentation';
export * from './checklistOrderRepresentation';
export * from './commentAuditInfo';
export * from './commentRepresentation';
export * from './completeFormRepresentation';
export * from './conditionRepresentation';
export * from './createEndpointBasicAuthRepresentation';
export * from './createProcessInstanceRepresentation';
export * from './createTenantRepresentation';
export * from './dataSourceConfigRepresentation';
export * from './dataSourceRepresentation';
export * from './decisionAuditRepresentation';
export * from './decisionTaskRepresentation';
export * from './endpointBasicAuthRepresentation';
export * from './endpointConfigurationRepresentation';
export * from './endpointRequestHeaderRepresentation';
export * from './entityAttributeScopeRepresentation';
export * from './entityVariableScopeRepresentation';
export * from './fieldValueInfo';
export * from './file';
export * from './formDefinitionRepresentation';
export * from './formFieldRepresentation';
export * from './formIdentifierRepresentation';
export * from './formJavascriptEventRepresentation';
export * from './formOutcomeRepresentation';
export * from './formRepresentation';
export * from './formSaveRepresentation';
export * from './formScopeRepresentation';
export * from './formTabRepresentation';
export * from './formValueRepresentation';
export * from './formVariableRepresentation';
export * from './globalDateFormatRepresentation';
export * from './googleDriveContent';
export * from './groupCapabilityRepresentation';
export * from './groupRepresentation';
export * from './historicProcessInstanceQueryRepresentation';
export * from './historicTaskInstanceQueryRepresentation';
export * from './identityLinkRepresentation';
export * from './imageUploadRepresentation';
export * from './jsonNode';
export * from './layoutRepresentation';
export * from './lightAppRepresentation';
export * from './lightGroupRepresentation';
export * from './lightTenantRepresentation';
export * from './lightUserRepresentation';
export * from './modelRepresentation';
export * from './namedObject';
export * from './objectNode';
export * from './optionRepresentation';
export * from './passwordValidationConstraints';
export * from './processContentRepresentation';
export * from './processDefinitionMetaDataRepresentation';
export * from './processDefinitionRepresentation';
export * from './processInstanceAuditInfoRepresentation';
export * from './processInstanceFilterRepresentation';
export * from './processInstanceFilterRequestRepresentation';
export * from './processInstanceQueryRepresentation';
export * from './processInstanceRepresentation';
export * from './processInstanceVariableRepresentation';
export * from './processScopeIdentifierRepresentation';
export * from './processScopeRepresentation';
export * from './processScopesRequestRepresentation';
export * from './publishIdentityInfoRepresentation';
export * from './queryVariable';
export * from './relatedContentRepresentation';
export * from './relatedProcessTask';
export * from './resetPasswordRepresentation';
export * from './restVariable';
export * from './resultListDataRepresentationAbstractUserRepresentation';
export * from './resultListDataRepresentationAccountRepresentation';
export * from './resultListDataRepresentationAlfrescoContentRepresentation';
export * from './resultListDataRepresentationAlfrescoEndpointRepresentation';
export * from './resultListDataRepresentationAlfrescoNetworkRepresenation';
export * from './resultListDataRepresentationAlfrescoSiteRepresenation';
export * from './resultListDataRepresentationAppDefinitionRepresentation';
export * from './resultListDataRepresentationAppDeploymentRepresentation';
export * from './resultListDataRepresentationBoxContent';
export * from './resultListDataRepresentationCommentRepresentation';
export * from './resultListDataRepresentationDataSourceRepresentation';
export * from './resultListDataRepresentationDecisionAuditRepresentation';
export * from './resultListDataRepresentationDecisionTaskRepresentation';
export * from './resultListDataRepresentationFormRepresentation';
export * from './resultListDataRepresentationGoogleDriveContent';
export * from './resultListDataRepresentationLightGroupRepresentation';
export * from './resultListDataRepresentationLightUserRepresentation';
export * from './resultListDataRepresentationModelRepresentation';
export * from './resultListDataRepresentationProcessContentRepresentation';
export * from './resultListDataRepresentationProcessDefinitionRepresentation';
export * from './resultListDataRepresentationProcessInstanceRepresentation';
export * from './resultListDataRepresentationRelatedContentRepresentation';
export * from './resultListDataRepresentationRuntimeDecisionTableRepresentation';
export * from './resultListDataRepresentationRuntimeFormRepresentation';
export * from './resultListDataRepresentationSubmittedFormRepresentation';
export * from './resultListDataRepresentationTaskRepresentation';
export * from './resultListDataRepresentationUserProcessInstanceFilterRepresentation';
export * from './resultListDataRepresentationUserTaskFilterRepresentation';
export * from './resultListDataRepresentationRelatedProcessTask';
export * from './runtimeAppDefinitionSaveRepresentation';
export * from './runtimeDecisionTableRepresentation';
export * from './runtimeFormRepresentation';
export * from './saveFormRepresentation';
export * from './submittedFormRepresentation';
export * from './syncLogEntryRepresentation';
export * from './systemPropertiesRepresentation';
export * from './taskAuditInfoRepresentation';
export * from './taskFilterRepresentation';
export * from './taskFilterRequestRepresentation';
export * from './taskQueryRepresentation';
export * from './taskRepresentation';
export * from './taskUpdateRepresentation';
export * from './tenantEvent';
export * from './tenantRepresentation';
export * from './userAccountCredentialsRepresentation';
export * from './userActionRepresentation';
export * from './userFilterOrderRepresentation';
export * from './userIdentifierRepresentation';
export * from './userProcessInstanceFilterRepresentation';
export * from './userRepresentation';
export * from './userTaskFilterRepresentation';
export * from './validationErrorRepresentation';
export * from './variableMappingRepresentation';
export * from './variableScopeRepresentation';
